import type { ProviderStudioListItem } from "@shared-kernel/application/ports/provider/provider-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveProviderStudios = createApiThunk<ProviderStudioListItem[], void>(
  "provider/studios/retrieve",
  async (_, { extra: { providerRepository } }) => {
    return providerRepository!.listStudios();
  },
);
